module.exports = __webpack_public_path__ + "img/gq1.d73480a3.png";